module.exports = __webpack_public_path__ + "img/thumbnail_BrownThroatedSloth_m_normal.f3881ef0.png";